import { render, staticRenderFns } from "./RegistryFieldEditor.vue?vue&type=template&id=00261b63"
import script from "./RegistryFieldEditor.vue?vue&type=script&lang=js"
export * from "./RegistryFieldEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00261b63')) {
      api.createRecord('00261b63', component.options)
    } else {
      api.reload('00261b63', component.options)
    }
    module.hot.accept("./RegistryFieldEditor.vue?vue&type=template&id=00261b63", function () {
      api.rerender('00261b63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/registry/RegistryFieldEditor.vue"
export default component.exports